import { FC } from 'react';
import { Box, Checkbox, Divider, FormLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CampaignMode, IMediaType } from '../../interfaces/campaign';
import { isCampaignCreateMode } from '../../utils/string';

type IAdType = {
	adType: IMediaType;
	selected: boolean;
	campaignMode: CampaignMode;
	onSelect: () => void;
};

const AdTypeBox: FC<IAdType> = ({ adType, selected, campaignMode, onSelect }) => {
	const { t } = useTranslation();

	const isCreateMode = isCampaignCreateMode(campaignMode);

	return (
		<Box className={`border-1 flex h-20 items-center rounded-lg ${!selected && 'border'} border-text-secondary py-4 pe-4 ps-6 ${isCreateMode && selected && 'bg-primary-main'} ${selected && !isCreateMode && 'border-action-disabled bg-grey-200 mix-blend-luminosity'} ${!isCreateMode && 'opacity-90'}`} onClick={isCreateMode ? onSelect : undefined}>
			<Checkbox className={`${selected && isCreateMode && 'text-background-paper'} m-0`} value={selected} checked={selected} disabled={!isCreateMode} />
			<FormLabel className={selected && isCreateMode ? 'text-background-paper' : 'text-text-primary'}>{t(adType.id)}</FormLabel>
			<Divider orientation="vertical" className={`me-4 ms-8 ${selected && isCreateMode ? 'bg-background-paper' : 'bg-action-focus'}`} sx={{ borderRightWidth: 2 }} />
			<Typography className={selected && isCreateMode ? 'text-background-paper' : 'text-text-secondary'}>{t(adType.description)}</Typography>
		</Box>
	);
};

export default AdTypeBox;
